import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { About } from '../components/About';
import { Founder } from '../components/Founder';
export function AboutPage() {
  return <main className="flex-grow pt-24" data-id="element-340">
      <div className="bg-midnight text-ivory py-24 text-center relative overflow-hidden" data-id="element-341">
        <div className="absolute top-0 right-0 w-1/2 h-full bg-gradient-to-l from-midnight-light to-transparent opacity-50 pointer-events-none" data-id="element-342" />

        <div className="relative z-10" data-id="element-343">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} className="inline-flex items-center gap-2 px-4 py-2 bg-white/10 rounded-full text-xs font-bold tracking-widest uppercase mb-6 text-gold" data-id="element-344">
            Our Story
          </motion.div>
          <motion.h1 initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} className="text-5xl md:text-7xl font-display font-bold tracking-tighter mb-6" data-id="element-345">
            About{' '}
            <span className="font-serif italic font-medium text-gold" data-id="element-346">Us</span>
          </motion.h1>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.1
        }} className="text-lg md:text-xl text-ivory/70 font-medium max-w-2xl mx-auto px-6" data-id="element-347">
            Discover the vision, mission, and history of Camp David Prayer
            Platform.
          </motion.p>
        </div>
      </div>

      <About data-id="element-348" />
      <Founder data-id="element-349" />

      <section className="py-32 bg-ivory text-midnight" data-id="element-350">
        <div className="max-w-4xl mx-auto px-6" data-id="element-351">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="bg-white p-8 md:p-16 rounded-[3rem] shadow-xl border-2 border-midnight/5" data-id="element-352">
            <div className="inline-flex items-center gap-2 px-4 py-2 bg-midnight/5 rounded-full text-xs font-bold tracking-widest uppercase mb-8 text-gold" data-id="element-353">
              Origin
            </div>
            <h2 className="text-4xl md:text-5xl font-display font-bold mb-12" data-id="element-354">
              History of <br data-id="element-355" />
              <span className="font-serif italic font-medium text-gold" data-id="element-356">
                Camp David Nation
              </span>
            </h2>

            <div className="prose prose-lg prose-slate max-w-none font-medium leading-relaxed text-charcoal/80 space-y-6" data-id="element-357">
              <p data-id="element-358">
                It all began with a vision at the Prayer Mountain of Christ
                Apostolic Church, at Arakeji in Osun State, Southwest of
                Nigeria. On the 16th - 18th Oct 2017, where God began to speak
                about Raising an Army of Exploits, they will be Last Days
                Armies, with the structure of Joel 2:1-12, Psalm 18:29. Upon
                completion of the retreat, divers encounters were birthed and
                sustained for preparation of the assignment that the Lord is
                commissioning us into.
              </p>
              <p data-id="element-359">
                In 2018, God came again in October 7th - 11th, at Mount Carmel
                Prayer Village, Ifewara, Osun State, this time he began to
                emphasis on the characteristics of the Davidic Army and raising
                a prophetic tribe that the weakest among us with be like David
                and the mighty men, While the strongest amongst us with be as
                God. Zech 12:8-11, 2Samuel 23:8-12.
              </p>
              <p data-id="element-360">
                The two major encounters were what led to the official flag off,
                we started with the name Armies of Exploits. As we progress into
                the future and gradually navigate into the promise of the Father
                who has commissioned the assignment, The name CAMP DAVID PRAYER
                PLATFORM came into existence.
              </p>
              <p data-id="element-361">
                This platform started with 3 members, having prayer meetings at
                the open field basement of the University of Benin. Prayer time
                was Fridays from 08:30pm till 11:30pm in January 2019. As the
                journey progressed, we then structure the Vision and Statement
                as it aligned with foundational instruction God gave us from the
                beginning.
              </p>
              <p data-id="element-362">
                In summary, God has been gracious and merciful to us in Camp
                David, In the last 7 years we have reached out to over 1700 less
                privileged Children, in 13 Orphanage homes across Benin City
                with the message of the Kingdom of God. Through our Correctional
                Centre outreaches, we have spread the message of hope and
                restoration to inmates with over 2700.
              </p>
              <p data-id="element-363">
                We have been blessings to rural dwellers by our Village and
                Welfare Community outreaches; we have impacted over 800 families
                in the last 7 years. Beyond our outreaches, we have organized
                spiritual empowerment programs such as retreats, camp meetings,
                Online Prayer meetings for spiritual edifications, only to
                mention a few.
              </p>

              <div className="my-12 p-8 bg-midnight text-ivory rounded-[2rem] rotate-1 shadow-lg" data-id="element-364">
                <p className="font-serif italic text-2xl md:text-3xl leading-snug" data-id="element-365">
                  "We are a City of Prayer, we are a nation of global armies of
                  exploits, we are intercessors, we are pathfinders and trail
                  blazers, we are called Camp David Nation."
                </p>
              </div>

              <div className="mt-12 flex items-center gap-4" data-id="element-366">
                <div className="w-12 h-1 bg-gold rounded-full" data-id="element-367" />
                <p className="font-display font-bold text-xl text-midnight" data-id="element-368">
                  Yours in Service, <br data-id="element-369" />
                  <span className="text-gold" data-id="element-370">Ajayi, Osagioduwa Joseph.</span>
                </p>
              </div>
            </div>
          </motion.div>
        </div>
      </section>
    </main>;
}